import { useMutation } from '@tanstack/vue-query'
import type { UpdateContractInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useRpQuery } from '~/composables/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useViewer } from '#imports'
import { useSelectedLanguage } from '~/composables/use-selected-language'

export function useRecurringProgramUpdateContractMutation() {
    const query = useRpQuery()
    const selectedLanguage = useSelectedLanguage()
    const activeFacility = useActiveFacility()
    const viewer = useViewer()

    return useMutation({
        mutationFn: (mutationData: UpdateContractInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation RecurringProgramUpdateContractMutation(
                        $input: UpdateContractInput!
                        $facilityId: ID!
                        $language: Language!
                        $capacityResultFilter: CapacityResultFilter!
                        $bookingStatusFilter: BookingStatusAvailableFilter!
                        $bookingPeriodFilter: BookingPeriodFilter!
                    ) {
                        updateContract(input: $input) {
                            __typename
                            ... on UpdateContractResult {
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseRecurringProgramContractFragment
                                        ...AnalyticsAddToCartResultFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id,
                    language: selectedLanguage.value,
                    capacityResultFilter: {
                        ignoreContractId: mutationData.id
                    },
                    bookingStatusFilter: {
                        customerId: viewer.value?.customerId ?? null
                    },
                    bookingPeriodFilter: {
                        customerId: viewer.value?.customerId ?? null
                    }
                }
            )
    })
}
